export default __webpack_public_path__ + "static/media/sidemenu_patient_list.0570c04e.svg";